'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _facetGroup = require('../components/facet-group');

var _facetGroup2 = _interopRequireDefault(_facetGroup);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _facetItemsPopup = require('./facetItemsPopup');

var _facetItemsPopup2 = _interopRequireDefault(_facetItemsPopup);

var _facetDatePickerPopup = require('./facetDatePickerPopup');

var _facetDatePickerPopup2 = _interopRequireDefault(_facetDatePickerPopup);

var _facetAvailabilityPopup = require('./facetAvailabilityPopup');

var _facetAvailabilityPopup2 = _interopRequireDefault(_facetAvailabilityPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Facets = function (_React$Component) {
    (0, _inherits3.default)(Facets, _React$Component);

    function Facets() {
        (0, _classCallCheck3.default)(this, Facets);
        return (0, _possibleConstructorReturn3.default)(this, (Facets.__proto__ || (0, _getPrototypeOf2.default)(Facets)).apply(this, arguments));
    }

    (0, _createClass3.default)(Facets, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var popupFacets = ['Authors', 'ProductTypes', 'Brands', 'PublishingHouses', 'Categories'];
            var groups = this.props.groups || [];
            var commissionAllowed = this.props.commissionAllowed;

            return _react2.default.createElement(
                'nav',
                { className: 'facets', id: 'accordionNo', 'aria-multiselectable': 'true' },
                _react2.default.createElement(
                    'button',
                    { id: 'show-filters-mobile',
                        className: 'visible-md visible-sm visible-xs btn btn-blue show-filters-mobile',
                        'data-text-close': (0, _localize2.default)("Common:HideFilters"),
                        'data-text-open': (0, _localize2.default)("Common:ShowFilters") },
                    _react2.default.createElement(
                        'span',
                        { className: 'text' },
                        (0, _localize2.default)("Common:ShowFilters")
                    ),
                    '\xA0\xA0',
                    _react2.default.createElement('i', {
                        className: 'fa fa-sliders' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-wrap' },
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown facets-with-popup' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-toggle' },
                            Resx.App.ProductFilters
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'facets-with-popup__body dropdown-menu' },
                            _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-options filter-button-author',
                                    'data-facet-group': 'Authors' },
                                Resx.Common.Author
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-date-picker filter-button-release-date',
                                    'data-facet-group': 'DateRelease' },
                                Resx.Common.DateRelease
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-options filter-button-product-type',
                                    'data-facet-group': 'ProductTypes',
                                    'data-hide-filtering-header': 'true' },
                                Resx.App.ProductTypes
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-options filter-button-brand',
                                    'data-facet-group': 'PublishingHouses' },
                                Resx.Common.Brands
                            )
                        )
                    ),
                    groups.filter(function (g) {
                        return popupFacets.indexOf(g.name) < 0;
                    }).map(function (g, i) {
                        return _react2.default.createElement(_facetGroup2.default, { group: g, key: i, onChange: _this2.props.onChange });
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown facets-with-popup' },
                        _react2.default.createElement(
                            'div',
                            { className: 'dropdown-toggle' },
                            Resx.Common.StockAvailability
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'facets-with-popup__body--2-items dropdown-menu' },
                            commissionAllowed ? _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-availability filter-button-my-state',
                                    'data-facet-icon': 'authors',
                                    'data-facet-group': 'StockAvailability' },
                                Resx.App.MyStockAvailability
                            ) : '',
                            _react2.default.createElement(
                                'div',
                                { className: 'facet-filter-button popup-availability filter-button-grada-state',
                                    'data-facet-icon': 'default',
                                    'data-facet-group': 'StockAvailability' },
                                Resx.App.StockAvailabilityGrada
                            )
                        )
                    )
                ),
                _react2.default.createElement(_facetItemsPopup2.default, null),
                _react2.default.createElement(_facetDatePickerPopup2.default, null),
                _react2.default.createElement(_facetAvailabilityPopup2.default, null)
            );
        }
    }]);
    return Facets;
}(_react2.default.Component);

exports.default = Facets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facets.js
// module id = 402
// module chunks = 0 1